import * as React from "react";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import Consultation from "../../components/Home/Consultation";
import DisplayYoutube from "../../components/Home/DisplayYoutube";

import PodcastAndBudget from "../../components/Home/PodcastAndBudget";

import { PrincipaleButton } from "../../components/PrincipaleButton";
import SocialMedia from "../../components/Home/SocialMedia";
import HappyClient from "../../components/HappyClient/HappyClient";

import "./HomePage.css"
import PodcastSection from "../../components/Home/PodcastSection";
import Contact from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";
import Pricing from "../../components/Pricing/Pricing";

const translationEn = {};
const translationAr = {};

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: translationEn },
    ar: { translation: translationAr },
  },
  lng: "en",
  fallbackLng: "eng",
  interpolation: { escapeVale: false },
});

export default function Homepage() {
  return (
    <>
      <React.Suspense fallback="Loading...">
        {/* <PodcastAndBudget PrincipaleButton={PrincipaleButton} /> */}
        <PodcastSection />
        <HappyClient/>
        <Pricing/>
        <DisplayYoutube PrincipaleButton={PrincipaleButton} />
        {/* <Consultation PrincipaleButton={PrincipaleButton} /> */}
        <Contact/>
        <Footer/>
        {/* <SocialMedia /> */}

      </React.Suspense>
    </>
  );
}
